import { lazy } from 'react';

export const coreIcons = {
  add: lazy(() => import('./Add')),
  arrowdown: lazy(() => import('./ArrowDown')),
  arrowdropdown: lazy(() => import('./ArrowDropdown')),
  checkbox: lazy(() => import('./Checkbox')),
  checkboxchecked: lazy(() => import('./CheckboxChecked')),
  checkboxindeterminate: lazy(() => import('./CheckboxIndeterminate')),
  checkmark: lazy(() => import('./Checkmark')),
  chevrondown: lazy(() => import('./ChevronDown')),
  chevronend: lazy(() => import('./ChevronEnd')),
  chevronleft: lazy(() => import('./ChevronLeft')),
  chevronright: lazy(() => import('./ChevronRight')),
  chevronstart: lazy(() => import('./ChevronStart')),
  chevronup: lazy(() => import('./ChevronUp')),
  chevronupdown: lazy(() => import('./ChevronUpDown')),
  closecircleoutlined: lazy(() => import('./CloseCircleOutlined')),
  cross: lazy(() => import('./Cross')),
  erroroutlined: lazy(() => import('./ErrorOutlined')),
  infooutlined: lazy(() => import('./InfoOutlined')),
  person: lazy(() => import('./Person')),
  radio: lazy(() => import('./Radio')),
  radiochecked: lazy(() => import('./RadioChecked')),
  search: lazy(() => import('./Search')),
  subtract: lazy(() => import('./Subtract')),
  successoutlined: lazy(() => import('./SuccessOutlined')),
  view: lazy(() => import('./View')),
  viewoff: lazy(() => import('./ViewOff')),
  warningoutlined: lazy(() => import('./WarningOutlined')),
};
